import { render, staticRenderFns } from "./BlogCategoryAdd.vue?vue&type=template&id=407847f3&"
import script from "./BlogCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports